import React from 'react';
import { Content } from './style';
import Modal from '../index';
import { useSelector } from 'react-redux';

interface IPdfNotify {
  handlerClose: () => void;
  billetMsg: string;
  billetWarning: boolean;
}

function PdfNotify({ handlerClose, billetMsg, billetWarning }: IPdfNotify) {
  return (
    <Modal
      title={'Aviso!'}
      handlerClose={handlerClose}
      width={
        window.matchMedia('(max-width: 960px)').matches ? '360px' : '464px'
      }
      billetWarning={billetWarning}
    >
      <Content>
        <div className='textDiv'>
          <p>{billetMsg}</p>
        </div>
      </Content>
    </Modal>
  );
}

export default PdfNotify;
